export const attachmentCount = (ticket) => {
  if (!ticket) return 0;
  return Number(
    ticket.attachments_count ??
      ticket.attachment_count ??
      ticket.attachmentsCount ??
      ticket.attachmentCount ??
      ticket.files_count ??
      0
  );
};

export const ticketHasAttachments = (ticket) =>
  attachmentCount(ticket) > 0 ||
  ticket?.has_attachments === true ||
  ticket?.hasAttachments === true ||
  ticket?.hasFiles === true;
